import PaymentInfoForm from './PaymentInfoForm'

export default PaymentInfoForm